'use client';
import {styled} from '@mui/material/styles';
import {SlickCarousel} from '@new-components/atoms/SlickCarousel';

export const OffersCarousel = styled(SlickCarousel)(({theme}) => ({
  '.slick-track': {
    marginLeft: '-16px !important',
    [theme.breakpoints.up('md')]: {
      marginLeft: '0 !important',
    },
    marginBottom: '12px',
    marginTop: '24px'
  },
  '.slick-slide > div': {
    marginRight: '12px',
    marginBottom: '12px',
  },
}));
